import { usePageDataStore } from '../stores/pageDataStore';

export default function useMeta() {
  const store = usePageDataStore();
  const meta = computed(() => store.getMeta);

  return meta;
}
